module.exports = __webpack_public_path__ + "assets/img/block-6ba05f65.png";